import React from 'react';

export default function ConfirmDialog({
  open,
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'danger',                // 'danger' | 'default'
  onConfirm,
  onCancel,
  autoCloseMs = null,             // optional: auto-dismiss after X ms
  hideCancel = false,             // optional: single-button notice
}) {
  const refCancel = React.useRef(null);
  const onCancelRef = React.useRef(onCancel);

  React.useEffect(() => {
    onCancelRef.current = onCancel;
  }, [onCancel]);

  React.useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => refCancel.current?.focus(), 0);
    const onKey = (e) => { if (e.key === 'Escape') onCancelRef.current?.(); };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      clearTimeout(t);
    };
  }, [open]);

  React.useEffect(() => {
    if (!open || !autoCloseMs) return;
    const timer = setTimeout(() => {
      if (onCancel) onCancel();
      else if (onConfirm) onConfirm();
    }, autoCloseMs);
    return () => clearTimeout(timer);
  }, [open, autoCloseMs, onCancel, onConfirm]);

  if (!open) return null;

  return (
    <div
      className="modal-backdrop"
      onClick={(e) => { if (e.target === e.currentTarget) onCancel?.(); }}
    >
      <div className="modal-card card" role="dialog" aria-modal="true" aria-labelledby="dlg-title">
        <h3 id="dlg-title" style={{ marginTop: 0 }}>{title}</h3>

        {typeof message === 'string'
          ? <p style={{ marginTop: 8 }}>{message}</p>
          : <div style={{ marginTop: 8 }}>{message}</div>
        }

        <div style={{ marginTop: 12, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          {!hideCancel && (
            <button className="secondary" ref={refCancel} onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
          <button className={tone === 'danger' ? 'danger' : ''} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
